import MFATotpPanel from "./mfa-totp-panel";
import MFAAdminGeneratedPanel from "./mfa-adming-generated-panel";
import MFAEmailPanel from "./mfa-email-panel";
import MFASmsPanel from "./mfa-sms-panel";
import MFAselectPanel from "./mfa-select-panel";

export {MFAselectPanel, MFAAdminGeneratedPanel, MFAEmailPanel, MFASmsPanel, MFATotpPanel};
